import { render, staticRenderFns } from "./CounterpartiesAgreementsEditPage.vue?vue&type=template&id=3bb77890"
import script from "./CounterpartiesAgreementsEditPage.vue?vue&type=script&lang=js"
export * from "./CounterpartiesAgreementsEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports